import axios from 'src/utils/axios';
import { addNotification } from 'src/actions/notificationActions';
import { getAccountInfo } from 'src/actions/accountActions';
import { NOTIFICATION_STATUS } from 'src/constants';
import helpers from 'src/helpers';

export const SET_LOADING = '@accountSettings/set-loading';
export const SET_FORM_ACCOUNT_TAB_OTHER = '@accountSettings/set-formAccountTabOther';
export const SET_FORM_ACCOUNT_TAB_CAMPAIGNS = '@accountSettings/set-formAccountTabCampaigns';
export const SET_CURRENT_NAVIGATION_TAB = '@accountSettings/set-current-navigation-tab';
// One-shot flag set by the persistent port-in-progress header banner.
// AccountDetailsStep consumes + clears it on mount so the Port-out PIN
// input scrolls into view and receives focus immediately, instead of
// landing the user at the top of the tab and forcing them to scroll and
// click the field themselves.
export const SET_SHOULD_SCROLL_TO_PORT_PIN = '@accountSettings/set-should-scroll-to-port-pin';
export const GET_USER_INFO_BY_ID = '@accountSettings/get-user-info-by-id';
export const GET_USER_INFO_BY_ID_ERROR = '@accountSettings/get-user-info-by-id-error';
export const UPDATE_USER_API_KEY = '@accountSettings/update-user-api-key';
export const UPDATE_ACCOUNT_REQUIRED = '@accountSettings/update-account-required';
export const UPDATE_ACCOUNT_CAMPAIGNS_TAGS = '@accountSettings/update-account-campaigns-tags';
export const UPDATE_ACCOUNT_OTHER = '@accountSettings/update-account-other';
export const UPDATE_USER_PASSWORD = '@accountSettings/update-user-password';

export const RETRIEVE_USER_SUBSCRIPTION = '@accountSettings/retrieve-user-subscription';

export const GET_USER_SUBSCRIPTION = '@accountSettings/get-user-subscription';
export const GET_USER_SUBSCRIPTION_SUCCESS = '@accountSettings/get-user-subscription-success';
export const GET_USER_SUBSCRIPTION_ERROR = '@accountSettings/get-user-subscription-error';

export const SUBSCRIBE = '@accountSettings/subscribe';
export const SUBSCRIBE_SUCCESS = '@accountSettings/subscribe-success';
export const SUBSCRIBE_ERROR = '@accountSettings/subscribe-error';

export const CANCEL_SUBSCRIPTION_AT_PERIOD_END = '@accountSettings/cancel-subscription-at-period-end';
export const CANCEL_SUBSCRIPTION_AT_PERIOD_END_SUCCESS = '@accountSettings/cancel-subscription-at-period-end-success';
export const CANCEL_SUBSCRIPTION_AT_PERIOD_END_ERROR = '@accountSettings/cancel-subscription-at-period-end-error';

export const UNSUBSCRIBE = '@accountSettings/unsubscribe';
export const UNSUBSCRIBE_SUCCESS = '@accountSettings/unsubscribe-success';
export const UNSUBSCRIBE_ERROR = '@accountSettings/unsubscribe-error';

export const UPDATE_SUBSCRIPTION_PAYMENT_METHOD = '@accountSettings/update-subscription-payment-method';
export const UPDATE_SUBSCRIPTION_PAYMENT_METHOD_SUCCESS = '@accountSettings/unsubscribe-success';
export const UPDATE_SUBSCRIPTION_PAYMENT_METHOD_ERROR = '@accountSettings/unsubscribe-error';

// CON-1481 — retry payment on past-due metered invoices
export const RETRY_METERED_INVOICE = '@accountSettings/retry-metered-invoice';
export const RETRY_METERED_INVOICE_SUCCESS = '@accountSettings/retry-metered-invoice-success';
export const RETRY_METERED_INVOICE_ERROR = '@accountSettings/retry-metered-invoice-error';

export const CREATE_REFERRAL_CODE = '@accountSettings/create-referral-code';
export const CREATE_REFERRAL_CODE_SUCCESS = '@accountSettings/create-referral-code-success';
export const CREATE_REFERRAL_CODE_ERROR = '@accountSettings/create-referral-code-error';

export const APPLY_REFERRAL_CODE = '@accountSettings/save-referred-salesperson';
export const APPLY_REFERRAL_CODE_SUCCESS = '@accountSettings/save-referred-salesperson-success';
export const APPLY_REFERRAL_CODE_ERROR = '@accountSettings/save-referred-salesperson-error';

export const CONFIRM_CONSULTANT = '@accountSettings/confirm-consultant';
export const CONFIRM_CONSULTANT_SUCCESS = '@accountSettings/confirm-consultant-success';
export const CONFIRM_CONSULTANT_ERROR = '@accountSettings/confirm-consultant-error';

export const UPDATE_FILTERS = '@accountSettings/update-filters';
export const UPDATE_FILTERS_SUCCESS = '@accountSettings/update-filters-success';
export const UPDATE_FILTERS_ERROR = '@accountSettings/update-filters-error';

export const GET_USER_COMPANY_SETTINGS = '@accountSettings/get-user-company-settings';
export const GET_USER_COMPANY_SETTINGS_SUCCESS = '@accountSettings/get-user-company-settings-success';
export const GET_USER_COMPANY_SETTINGS_ERROR = '@accountSettings/get-user-company-settings-error';

export const GET_USER_CAMPAIGNS = '@accountSettings/get-user-campaigns';
export const GET_USER_CAMPAIGNS_SUCCESS = '@accountSettings/get-user-campaigns-success';
export const GET_USER_CAMPAIGNS_ERROR = '@accountSettings/get-user-campaigns-error';

export const GET_AVAILABLE_REGIONS_LIST = '@accountSettings/get-available-regions-list';
export const GET_AVAILABLE_REGIONS_LIST_SUCCESS = '@accountSettings/get-available-regions-list-success';
export const GET_AVAILABLE_REGIONS_LIST_ERROR = '@accountSettings/get-available-regions-list-error';

export const GET_AVAILABLE_PHONE_NUMBERS_FOR_REGION = '@accountSettings/get-available-phone-numbers-for-region';
export const GET_AVAILABLE_PHONE_NUMBERS_FOR_REGION_SUCCESS = '@accountSettings/get-available-phone-numbers-for-region-success';
export const GET_AVAILABLE_PHONE_NUMBERS_FOR_REGION_ERROR = '@accountSettings/get-available-phone-numbers-for-region-error';

export const CONFIRM_SELECTED_PHONE_NUMBER = '@accountSettings/confirm-selected-phone-number';
export const CONFIRM_SELECTED_PHONE_NUMBER_SUCCESS = '@accountSettings/confirm-selected-phone-number-success';
export const CONFIRM_SELECTED_PHONE_NUMBER_ERROR = '@accountSettings/confirm-selected-phone-number-error';

export const GET_TCR_DETAILS = '@accountSettings/get-tcr-details';
export const GET_TCR_DETAILS_SUCCESS = '@accountSettings/get-tcr-details-success';
export const GET_TCR_DETAILS_ERROR = '@accountSettings/get-tcr-details-error';

export const UPDATE_TCR_DETAILS = '@accountSettings/update-tcr-details';
export const UPDATE_TCR_DETAILS_SUCCESS = '@accountSettings/update-tcr-details-success';
export const UPDATE_TCR_DETAILS_ERROR = '@accountSettings/update-tcr-details-error';

export const SET_FILL_DEFAULT_VALUES = '@accountSettings/set-fill-default-values';
export const SET_VISIBLE_MODAL_FORM_NUMBER = '@accountSettings/set-visible-modal-form-number';

export const RESEND_TCR_VERIFICATION_SMS = '@accountSettings/resend-tcr-verification-sms';
export const RESEND_TCR_VERIFICATION_SMS_SUCCESS = '@accountSettings/resend-tcr-verification-sms-success';
export const RESEND_TCR_VERIFICATION_SMS_ERROR = '@accountSettings/resend-tcr-verification-sms-error';

export const CREATE_TCR_REGISTRATION = '@accountSettings/create-tcr-registration';
export const CREATE_TCR_REGISTRATION_SUCCESS = '@accountSettings/create-tcr-registration-success';
export const CREATE_TCR_REGISTRATION_ERROR = '@accountSettings/create-tcr-registration-error';

export const GET_TCR_CHARGES = '@accountSettings/get-tcr-charges';
export const GET_TCR_CHARGES_SUCCESS = '@accountSettings/get-tcr-charges-success';
export const GET_TCR_CHARGES_ERROR = '@accountSettings/get-tcr-charges-error';

export const PAY_TCR_REGISTRATION = '@accountSettings/pay-tcr-registration';
export const PAY_TCR_REGISTRATION_SUCCESS = '@accountSettings/pay-tcr-registration-success';
export const PAY_TCR_REGISTRATION_ERROR = '@accountSettings/pay-tcr-registration-error';

export const GET_PHONE_NUMBER_PORT_DETAILS = 'GET_PHONE_NUMBER_PORT_DETAILS';
export const GET_PHONE_NUMBER_PORT_DETAILS_SUCCESS = 'GET_PHONE_NUMBER_PORT_DETAILS_SUCCESS';
export const GET_PHONE_NUMBER_PORT_DETAILS_ERROR = 'GET_PHONE_NUMBER_PORT_DETAILS_ERROR';

export const UPDATE_PHONE_NUMBER_PORT_DETAILS = 'UPDATE_PHONE_NUMBER_PORT_DETAILS';
export const UPDATE_PHONE_NUMBER_PORT_DETAILS_SUCCESS = 'UPDATE_PHONE_NUMBER_PORT_DETAILS_SUCCESS';
export const UPDATE_PHONE_NUMBER_PORT_DETAILS_ERROR = 'UPDATE_PHONE_NUMBER_PORT_DETAILS_ERROR';

export const SUBMIT_PHONE_NUMBER_PORT_REQUEST = 'SUBMIT_PHONE_NUMBER_PORT_REQUEST';
export const SUBMIT_PHONE_NUMBER_PORT_REQUEST_SUCCESS = 'SUBMIT_PHONE_NUMBER_PORT_REQUEST_SUCCESS';
export const SUBMIT_PHONE_NUMBER_PORT_REQUEST_ERROR = 'SUBMIT_PHONE_NUMBER_PORT_REQUEST_ERROR';

export const FINISH_PHONE_NUMBER_PORT = 'FINISH_PHONE_NUMBER_PORT';
export const FINISH_PHONE_NUMBER_PORT_SUCCESS = 'FINISH_PHONE_NUMBER_PORT_SUCCESS';
export const FINISH_PHONE_NUMBER_PORT_ERROR = 'FINISH_PHONE_NUMBER_PORT_ERROR';
export const SUBMIT_PHONE_PORT_NOW = 'SUBMIT_PHONE_PORT_NOW';
export const SUBMIT_PHONE_PORT_NOW_SUCCESS = 'SUBMIT_PHONE_PORT_NOW_SUCCESS';
export const SUBMIT_PHONE_PORT_NOW_ERROR = 'SUBMIT_PHONE_PORT_NOW_ERROR';

export const ABANDON_PHONE_NUMBER_PORT_DRAFT = 'ABANDON_PHONE_NUMBER_PORT_DRAFT';
export const ABANDON_PHONE_NUMBER_PORT_DRAFT_SUCCESS = 'ABANDON_PHONE_NUMBER_PORT_DRAFT_SUCCESS';
export const ABANDON_PHONE_NUMBER_PORT_DRAFT_ERROR = 'ABANDON_PHONE_NUMBER_PORT_DRAFT_ERROR';

export const GET_CONTACT_CARD = '@accountSettings/get-contact-card';
export const GET_CONTACT_CARD_SUCCESS = '@accountSettings/get-contact-card-success';
export const GET_CONTACT_CARD_ERROR = '@accountSettings/get-contact-card-error';

export const UPDATE_CONTACT_CARD = '@accountSettings/update-contact-card';
export const UPDATE_CONTACT_CARD_SUCCESS = '@accountSettings/update-contact-card-success';
export const UPDATE_CONTACT_CARD_ERROR = '@accountSettings/update-contact-card-error';
export const VALIDATE_ADDRESS = '@accountSettings/validate-address';
export const VALIDATE_ADDRESS_SUCCESS = '@accountSettings/validate-address-success';
export const VALIDATE_ADDRESS_ERROR = '@accountSettings/validate-address-error';

export const setLoading = (loading) => ({
  type: SET_LOADING,
  payload: loading
});

export const setFormAccountTabOther = (formAccountTabOther) => ({
  type: SET_FORM_ACCOUNT_TAB_OTHER,
  payload: formAccountTabOther
});

export const setFormAccountTabCampaigns = (formAccountTabCampaigns) => ({
  type: SET_FORM_ACCOUNT_TAB_CAMPAIGNS,
  payload: formAccountTabCampaigns
});

export const setCurrentNavigationTab = (tabName) => ({
  type: SET_CURRENT_NAVIGATION_TAB,
  payload: tabName
});

export const setShouldScrollToPortPin = (value) => ({
  type: SET_SHOULD_SCROLL_TO_PORT_PIN,
  payload: !!value,
});

export const getUserInfoById = (salespersonId) => async (dispatch) => {
  try {
    dispatch(setLoading(true));
    const response = await axios.get(`/api/accountsettings/${salespersonId}`);
    const error = response?.data?.error;
    if (error) {
      dispatch(addNotification(GET_USER_INFO_BY_ID_ERROR, error, NOTIFICATION_STATUS.ERROR));
      dispatch({
        type: GET_USER_INFO_BY_ID_ERROR,
      });
      return;
    }
    dispatch({
      type: GET_USER_INFO_BY_ID,
      payload: response?.data || {},
    });
  } catch (e) {
    const error = e?.response?.data?.error;
    dispatch(addNotification(GET_USER_INFO_BY_ID_ERROR, error || 'Server error', NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: GET_USER_INFO_BY_ID_ERROR,
    });
  }
};

export const getUserCompanySettings = () => async (dispatch) => {
  try {
    dispatch({
      type: GET_USER_COMPANY_SETTINGS,
    });

    const response = await axios.post('/api/accountsettings/companySettings', {});

    const { error } = response?.data || {};
    if (error) {
      dispatch(addNotification(GET_USER_COMPANY_SETTINGS_ERROR, error, NOTIFICATION_STATUS.ERROR));
      dispatch({
        type: GET_USER_COMPANY_SETTINGS_ERROR,
      });
      return;
    }

    dispatch({
      type: GET_USER_COMPANY_SETTINGS_SUCCESS,
      payload: response?.data || [],
    });
  } catch (e) {
    const {
      message,
      error,
    } = e?.response?.data || {};
    const { message: errorMessage } = error || {};
    dispatch(addNotification(GET_USER_COMPANY_SETTINGS_ERROR, message || errorMessage || error || 'Server error', NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: GET_USER_COMPANY_SETTINGS_ERROR,
    });
  }
};

export const getUserCampaigns = (options = {}) => async (dispatch) => {
  try {
    dispatch({
      type: GET_USER_CAMPAIGNS,
    });
    const {
      types,
      status,
    } = options || {};
    const response = await axios.post('/api/accountsettings/userCampaignsList', {
      ...types ? { types } : {},
      ...status ? { status } : {},
    });

    const { error } = response?.data || {};
    if (error) {
      dispatch(addNotification(GET_USER_CAMPAIGNS_ERROR, error, NOTIFICATION_STATUS.ERROR));
      dispatch({
        type: GET_USER_CAMPAIGNS_ERROR,
      });
      return;
    }

    dispatch({
      type: GET_USER_CAMPAIGNS_SUCCESS,
      payload: response?.data || [],
    });
  } catch (e) {
    const {
      message,
      error,
    } = e?.response?.data || {};
    const { message: errorMessage } = error || {};
    dispatch(addNotification(GET_USER_CAMPAIGNS_ERROR, message || errorMessage || error || 'Server error', NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: GET_USER_CAMPAIGNS_ERROR,
    });
  }
};

export const updateUserApiKey = (userId, apiKey, doWhenTry = false, doWhenCatch = false) => async (dispatch) => {
  try {
    dispatch(setLoading(true));
    const accountChanges = { apiKey };
    const response = await axios.put('/api/accountsettings/apiKey', { accountChanges });
    const error = response?.data?.error;

    if (error) {
      dispatch(addNotification(UPDATE_USER_API_KEY, error, NOTIFICATION_STATUS.ERROR));
      dispatch(setLoading(false));
      return;
    }

    await dispatch(getUserInfoById(userId));
    // CON-1711: the PB template + campaign import buttons are gated on
    // state.account (pbAPIKeyValid + user.userMessagingSystem.apiKey), which
    // getUserInfoById does not touch — it only refreshes the accountSettings
    // slice. Without this the buttons stayed hidden until the next page load.
    // Matches updateAccountRequired below.
    await dispatch(getAccountInfo());
    dispatch(addNotification(UPDATE_USER_API_KEY, 'API Key updated', NOTIFICATION_STATUS.SUCCESS));

    if (doWhenTry) {
      doWhenTry();
    }
  } catch (e) {
    const error = e?.response?.data?.error;
    dispatch(addNotification(UPDATE_USER_API_KEY, error || 'Server error', NOTIFICATION_STATUS.ERROR));
    dispatch(setLoading(false));

    if (doWhenCatch) {
      doWhenCatch(e);
    }
  }
};

export const updateAccountRequired = (userId, accountChanges, doWhenTry = false, doWhenCatch = false) => async (dispatch, getState) => {
  try {
    dispatch(setLoading(true));
    const { fillDefaultValues } = getState()?.accountSettings || {};
    const response = await axios.put('/api/accountsettings/required', {
      accountChanges: {
        ...accountChanges,
        fillDefaultValues,
      },
    });
    const responseAddress = await axios.put('/api/accountsettings/requiredhomeaddress', { accountChanges });
    const error = response?.data?.error || responseAddress?.data?.error;

    if (error) {
      dispatch(addNotification(UPDATE_ACCOUNT_REQUIRED, error, NOTIFICATION_STATUS.ERROR));
      dispatch(getUserInfoById(userId));
      return;
    }

    await dispatch(getUserInfoById(userId));
    await dispatch(getAccountInfo());
    dispatch(addNotification(UPDATE_ACCOUNT_REQUIRED, 'Your settings have been successfully updated', NOTIFICATION_STATUS.SUCCESS));

    if (doWhenTry) {
      doWhenTry();
    }
  } catch (e) {
    const error = e?.response?.data?.error;
    dispatch(addNotification(UPDATE_ACCOUNT_REQUIRED, error || 'Try again later', NOTIFICATION_STATUS.ERROR));
    dispatch(getUserInfoById(userId));

    if (doWhenCatch) {
      doWhenCatch(e);
    }
  }
};

export const updateAccountCampaigns = (userId, accountChanges, doWhenTry = false, doWhenCatch = false) => async (dispatch) => {
  try {
    dispatch(setLoading(true));
    const response = await axios.put('/api/accountsettings/campaignstags', { accountChanges });
    const error = response?.data?.error;

    if (error) {
      dispatch(addNotification(UPDATE_ACCOUNT_CAMPAIGNS_TAGS, error, NOTIFICATION_STATUS.ERROR));
      dispatch(getUserInfoById(userId));
      return;
    }

    await dispatch(getUserInfoById(userId));
    dispatch(addNotification(UPDATE_ACCOUNT_CAMPAIGNS_TAGS, 'Your settings have been successfully updated', NOTIFICATION_STATUS.SUCCESS));

    if (doWhenTry) {
      doWhenTry();
    }
  } catch (e) {
    const error = e?.response?.data?.error;
    dispatch(addNotification(UPDATE_ACCOUNT_CAMPAIGNS_TAGS, error || 'Try again later', NOTIFICATION_STATUS.ERROR));
    dispatch(getUserInfoById(userId));

    if (doWhenCatch) {
      doWhenCatch(e);
    }
  }
};

export const refreshCampaigns = (userId, doWhenTry = false, doWhenCatch = false) => async (dispatch) => {
  try {
    dispatch(setLoading(true));
    await axios.put('/api/accountsettings/campaignsrefresh');

    await dispatch(getUserInfoById(userId));
    dispatch(addNotification(UPDATE_ACCOUNT_OTHER, 'Your Campaign list has been successfully refreshed.', NOTIFICATION_STATUS.SUCCESS));

    if (doWhenTry) {
      doWhenTry();
    }
  } catch (e) {
    const error = e?.response?.data?.error;
    dispatch(addNotification(UPDATE_ACCOUNT_OTHER, error || 'Try again later', NOTIFICATION_STATUS.ERROR));
    dispatch(getUserInfoById(userId));

    if (doWhenCatch) {
      doWhenCatch(e);
    }
  }
};

export const updateAccountOther = (userId, accountChanges, doWhenTry = false, doWhenCatch = false) => async (dispatch) => {
  try {
    dispatch(setLoading(true));
    const response = await axios.put('/api/accountsettings/other', { accountChanges });
    const error = response?.data?.error;

    if (error) {
      dispatch(addNotification(UPDATE_ACCOUNT_OTHER, error, NOTIFICATION_STATUS.ERROR));
      dispatch(getUserInfoById(userId));
      return;
    }

    await dispatch(getUserInfoById(userId));
    dispatch(addNotification(UPDATE_ACCOUNT_OTHER, 'Your settings have been successfully updated', NOTIFICATION_STATUS.SUCCESS));

    if (doWhenTry) {
      doWhenTry();
    }
  } catch (e) {
    const error = e?.response?.data?.error;
    dispatch(addNotification(UPDATE_ACCOUNT_OTHER, error || 'Try again later', NOTIFICATION_STATUS.ERROR));
    dispatch(getUserInfoById(userId));

    if (doWhenCatch) {
      doWhenCatch(e);
    }
  }
};

export const refreshCustomFields = (userId, doWhenCatch = false) => async (dispatch) => {
  try {
    dispatch(setLoading(true));
    // const response = await axios.put('/api/accountsettings/customfieldsrefresh');
    await axios.put('/api/accountsettings/customfieldsrefresh');

    dispatch(getUserInfoById(userId));
    dispatch(getAccountInfo());

    dispatch(addNotification(UPDATE_ACCOUNT_OTHER, 'Your Custom Fields have been successfully refreshed', NOTIFICATION_STATUS.SUCCESS));
  } catch (e) {
    const error = e?.response?.data?.error;
    dispatch(addNotification(UPDATE_ACCOUNT_OTHER, error || 'Try again later', NOTIFICATION_STATUS.ERROR));
    dispatch(getUserInfoById(userId));
    dispatch(getAccountInfo());

    if (doWhenCatch) {
      doWhenCatch(e);
    }
  }
};

export const updateUserPassword = (userId, accountChanges, doWhenTry = false, doWhenCatch = false) => async (dispatch) => {
  try {
    dispatch(setLoading(true));
    const response = await axios.put('/api/accountsettings/pwdchange', accountChanges);
    const error = response?.data?.error;

    if (error) {
      dispatch(addNotification(UPDATE_USER_PASSWORD, error, NOTIFICATION_STATUS.ERROR));
      dispatch(setLoading(false));
      return;
    }

    await dispatch(getUserInfoById(userId));
    dispatch(addNotification(UPDATE_USER_PASSWORD, 'Your password has been successfully updated', NOTIFICATION_STATUS.SUCCESS));

    if (doWhenTry) {
      doWhenTry();
    }
  } catch (e) {
    const error = e?.response?.data?.error;
    dispatch(addNotification(UPDATE_USER_PASSWORD, error || 'Try again later', NOTIFICATION_STATUS.ERROR));
    dispatch(setLoading(false));

    if (doWhenCatch) {
      doWhenCatch(e);
    }
  }
};

export const reloadSubscription = () => async (dispatch, getState) => {
  try {
    const { wasPaymentRequestSent } = getState()?.account?.user?.userSubscription || {};
    if (!wasPaymentRequestSent) {
      return;
    }

    const response = await axios.get('/api/usersubscription/');
    dispatch({
      type: RETRIEVE_USER_SUBSCRIPTION,
      payload: response?.data || {}
    });

    if (helpers.isPaymentRequestActive(response?.data?.wasPaymentRequestSent)) {
      setTimeout(() => {
        dispatch(reloadSubscription());
      }, 4000);
    }
  } catch (e) {
    dispatch(addNotification(RETRIEVE_USER_SUBSCRIPTION, 'Server error. Please refresh your page.', NOTIFICATION_STATUS.ERROR));
  }
};

export const getAvailableRegionslist = () => async (dispatch) => {
  dispatch({
    type: GET_AVAILABLE_REGIONS_LIST,
  });
  try {
    const response = await axios.get('/api/usersubscription/available-regions');

    dispatch({
      type: GET_AVAILABLE_REGIONS_LIST_SUCCESS,
      payload: response?.data || {}
    });
  } catch (e) {
    const {
      error,
      message,
    } = e?.response?.data || {};
    dispatch(addNotification(GET_AVAILABLE_REGIONS_LIST_ERROR, helpers.transform.toString(message || error || 'Server error'), NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: GET_AVAILABLE_REGIONS_LIST_ERROR,
    });
  }
};

export const getAvailablePhoneNumbersForRegion = (areaCode, countryId) => async (dispatch) => {
  dispatch({
    type: GET_AVAILABLE_PHONE_NUMBERS_FOR_REGION,
  });
  try {
    const params = {
      areaCode,
      countryId,
    };
    const response = await axios.get('/api/usersubscription/available-phone-numbers', { params });

    dispatch({
      type: GET_AVAILABLE_PHONE_NUMBERS_FOR_REGION_SUCCESS,
      payload: response?.data || {}
    });
  } catch (e) {
    const {
      error,
      message,
    } = e?.response?.data || {};
    dispatch(addNotification(GET_AVAILABLE_PHONE_NUMBERS_FOR_REGION_ERROR, helpers.transform.toString(message || error || 'Server error'), NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: GET_AVAILABLE_PHONE_NUMBERS_FOR_REGION_ERROR,
    });
  }
};

export const clearAvailablePhoneNumbersForRegion = () => ({
  type: GET_AVAILABLE_PHONE_NUMBERS_FOR_REGION_ERROR,
});

export const confirmSelectedPhoneNumber = (payload, doWhenTry = false, doWhenCatch = false) => async (dispatch) => {
  try {
    dispatch({
      type: CONFIRM_SELECTED_PHONE_NUMBER,
    });
    const response = await axios.post('/api/usersubscription/activate-phone-number', payload);
    const { status } = response?.data || {};

    if (!status === 'success') {
      dispatch(addNotification(CONFIRM_SELECTED_PHONE_NUMBER_ERROR, 'Could not acquire the phone number', NOTIFICATION_STATUS.ERROR));
      dispatch({
        type: CONFIRM_SELECTED_PHONE_NUMBER_ERROR,
      });
      return;
    }
    dispatch({
      type: CONFIRM_SELECTED_PHONE_NUMBER_SUCCESS,
    });
    dispatch(getAccountInfo());

    if (doWhenTry) {
      doWhenTry();
    }
  } catch (e) {
    const {
      message,
      error,
    } = e?.response?.data || {};
    dispatch(addNotification(CONFIRM_SELECTED_PHONE_NUMBER_ERROR, helpers.transform.toString(message || error || 'Server error'), NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: CONFIRM_SELECTED_PHONE_NUMBER_ERROR,
    });

    if (doWhenCatch) {
      doWhenCatch();
    }
  }
};

export const getTCRDetails = () => async (dispatch) => {
  dispatch({
    type: GET_TCR_DETAILS,
  });
  try {
    const response = await axios.get('/api/accountsettings/tcr');

    const { error } = response?.data || {};
    if (error) {
      dispatch(addNotification(GET_TCR_DETAILS_ERROR, error, NOTIFICATION_STATUS.ERROR));
      dispatch({
        type: GET_TCR_DETAILS_ERROR,
      });
      return;
    }

    dispatch({
      type: GET_TCR_DETAILS_SUCCESS,
      payload: response?.data || {},
    });
  } catch (e) {
    const {
      error,
      message,
    } = e?.response?.data || {};

    // Don't show error notification if it's just a 401 (user not authenticated)
    if (e?.response?.status !== 401) {
      dispatch(addNotification(GET_TCR_DETAILS_ERROR, helpers.transform.toString(message || error || 'Server error'), NOTIFICATION_STATUS.ERROR));
    }

    dispatch({
      type: GET_TCR_DETAILS_ERROR,
    });
  }
};

export const updateTCRDetails = (sendData, doWhenTry = false, doWhenCatch = false) => async (dispatch) => {
  dispatch({
    type: UPDATE_TCR_DETAILS,
  });
  try {
    const cleanData = (data) => JSON.parse(JSON.stringify(data, (key, value) => {
      // Skip functions, symbols, and undefined values
      if (typeof value === 'function' || typeof value === 'symbol' || value === undefined) {
        return null;
      }
      // Handle objects that might have circular references
      if (value && typeof value === 'object') {
        // Remove any React/DOM objects or circular references
        if (value.constructor && value.constructor.name !== 'Object' && value.constructor.name !== 'Array') {
          return null;
        }
      }
      return value;
    }));

    const cleanedData = cleanData(sendData);

    try {
      const response = await axios.patch('/api/accountsettings/tcr', cleanedData);
      dispatch({
        type: UPDATE_TCR_DETAILS_SUCCESS,
        payload: response?.data || {}
      });
    } catch (error) {
      console.log('=== FRONTEND: Request failed ===');
      console.log('Error:', error);
      console.log('Error response:', error.response);
      console.log('Error message:', error.message);
      throw error;
    }

    if (doWhenTry) {
      doWhenTry();
    }
    return true; // Indicate success
  } catch (e) {
    const {
      error,
      message,
    } = e?.response?.data || {};
    dispatch(addNotification(UPDATE_TCR_DETAILS_ERROR, helpers.transform.toString(message || error || 'Server error'), NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: UPDATE_TCR_DETAILS_ERROR,
    });

    if (doWhenCatch) {
      doWhenCatch(e);
    }
    return false; // Indicate failure
  }
};

export const validateAddress = (addressData) => async (dispatch) => {
  dispatch({
    type: VALIDATE_ADDRESS,
  });
  try {
    const response = await axios.post('/api/accountsettings/validate-address', addressData);

    const { error } = response?.data || {};
    if (error) {
      dispatch({
        type: VALIDATE_ADDRESS_ERROR,
        payload: { error },
      });
      return { success: false, error };
    }

    dispatch({
      type: VALIDATE_ADDRESS_SUCCESS,
      payload: response?.data || {},
    });

    return response?.data || {};
  } catch (e) {
    const {
      error,
      message,
    } = e?.response?.data || {};

    dispatch({
      type: VALIDATE_ADDRESS_ERROR,
      payload: { error: message || error || 'Failed to validate address' },
    });

    return { success: false, error: message || error || 'Failed to validate address' };
  }
};

// When otpPin is provided, the backend interprets the request as "verify this
// PIN" (Telnyx flow), marks the brand verified, and creates the campaign.
// When otpPin is omitted, the backend resends the verification SMS.
// The Lumian flow only uses the no-arg form.
export const resendTCRVerificationSMS = (otpPin) => async (dispatch) => {
  dispatch({
    type: RESEND_TCR_VERIFICATION_SMS,
  });
  try {
    const response = await axios.post(
      '/api/accountsettings/tcr/resend-verification',
      otpPin ? { otpPin } : {},
    );

    dispatch({
      type: RESEND_TCR_VERIFICATION_SMS_SUCCESS,
      payload: response?.data || {},
    });

    return { success: true, data: response?.data || {} };
  } catch (e) {
    const {
      error,
      message,
    } = e?.response?.data || {};

    dispatch(addNotification(RESEND_TCR_VERIFICATION_SMS_ERROR, helpers.transform.toString(message || error || 'Server error'), NOTIFICATION_STATUS.ERROR));

    dispatch({
      type: RESEND_TCR_VERIFICATION_SMS_ERROR,
    });

    return { success: false, error: message || error };
  }
};

export const createTCRRegistration = (businessTypeData) => async (dispatch) => {
  dispatch({
    type: CREATE_TCR_REGISTRATION,
  });
  try {
    const response = await axios.post('/api/accountsettings/tcr/create-tcr-registration', businessTypeData);

    const { error } = response?.data || {};
    if (error) {
      dispatch(addNotification(CREATE_TCR_REGISTRATION_ERROR, error, NOTIFICATION_STATUS.ERROR));
      dispatch({
        type: CREATE_TCR_REGISTRATION_ERROR,
      });
      return { error: true, message: error };
    }

    dispatch({
      type: CREATE_TCR_REGISTRATION_SUCCESS,
      payload: response?.data || {},
    });

    return { success: true, data: response?.data };
  } catch (e) {
    const {
      error,
      message,
    } = e?.response?.data || {};
    dispatch(addNotification(CREATE_TCR_REGISTRATION_ERROR, helpers.transform.toString(message || error || 'Server error'), NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: CREATE_TCR_REGISTRATION_ERROR,
    });
    return { error: true, message: message || error || 'Server error' };
  }
};

// Action to get TCR charges
export const getTCRCharges = (businessType) => async (dispatch) => {
  dispatch({
    type: GET_TCR_CHARGES,
  });
  try {
    const response = await axios.get(`/api/tcr/tcr-charges?businessType=${businessType}`);

    const { error } = response?.data || {};
    if (error) {
      dispatch(addNotification(GET_TCR_CHARGES_ERROR, error, NOTIFICATION_STATUS.ERROR));
      dispatch({
        type: GET_TCR_CHARGES_ERROR,
      });
      return { error: true, message: error };
    }

    dispatch({
      type: GET_TCR_CHARGES_SUCCESS,
      payload: response?.data || {},
    });

    return { success: true, data: response?.data };
  } catch (e) {
    const {
      error,
      message,
    } = e?.response?.data || {};
    dispatch(addNotification(GET_TCR_CHARGES_ERROR, helpers.transform.toString(message || error || 'Server error'), NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: GET_TCR_CHARGES_ERROR,
    });
    return { error: true, message: message || error || 'Server error' };
  }
};

// Action to pay for TCR registration
export const payTCRRegistration = (paymentData) => async (dispatch) => {
  dispatch({
    type: PAY_TCR_REGISTRATION,
  });
  try {
    const response = await axios.post('/api/usersubscription/pay-tcr-registration', paymentData);

    const { error } = response?.data || {};
    if (error) {
      dispatch(addNotification(PAY_TCR_REGISTRATION_ERROR, error, NOTIFICATION_STATUS.ERROR));
      dispatch({
        type: PAY_TCR_REGISTRATION_ERROR,
      });
      return { error: true, message: error };
    }

    dispatch({
      type: PAY_TCR_REGISTRATION_SUCCESS,
      payload: response?.data || {},
    });

    dispatch(addNotification(PAY_TCR_REGISTRATION_SUCCESS, 'TCR registration payment completed successfully', NOTIFICATION_STATUS.SUCCESS));
    return { success: true, data: response?.data };
  } catch (e) {
    const {
      error,
      message,
    } = e?.response?.data || {};
    dispatch(addNotification(PAY_TCR_REGISTRATION_ERROR, helpers.transform.toString(message || error || 'Server error'), NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: PAY_TCR_REGISTRATION_ERROR,
    });
    return { error: true, message: message || error || 'Server error' };
  }
};

export const getUserSubscription = (withoutNotification = false) => async (dispatch) => {
  dispatch({
    type: GET_USER_SUBSCRIPTION,
  });
  try {
    const response = await axios.get('/api/usersubscription/');

    dispatch({
      type: GET_USER_SUBSCRIPTION_SUCCESS,
      payload: response?.data || {}
    });
  } catch (e) {
    const { message } = e?.response?.data || {};
    dispatch({
      type: GET_USER_SUBSCRIPTION_ERROR,
    });
    if (!withoutNotification) {
      dispatch(addNotification(GET_USER_SUBSCRIPTION_ERROR, message || 'Server error', NOTIFICATION_STATUS.ERROR));
    }
  }
};

export const subscribe = (stripePaymentMethodId, subscriptionId, businessTypeData = null) => async (dispatch, getState) => {
  dispatch({
    type: SUBSCRIBE,
  });
  try {
    const { referralCode } = getState()?.subscriptions?.formReferralCodeSendData || {};
    const { subscriptions } = getState()?.subscriptions || {};
    const { isReferredSalespersonId } = getState()?.account?.user?.userSubscription || {};

    // Find the selected subscription and check if promo is active
    const selectedSubscription = subscriptions?.find((sub) => sub.id === subscriptionId);
    const usePromotion = selectedSubscription?.promo?.isActive || false;

    const response = await axios.post('/api/usersubscription/subscribe', {
      subscriptionId,
      stripePaymentMethodId,
      ...referralCode && !isReferredSalespersonId ? { referralCode: helpers.removeSpace(referralCode) } : {},
      usePromotion,
      businessTypeData, // Include business type data
    });

    dispatch({
      type: SUBSCRIBE_SUCCESS,
      payload: response?.data || {}
    });

    dispatch(addNotification(SUBSCRIBE_SUCCESS, 'Thank you! Payment information accepted.', NOTIFICATION_STATUS.SUCCESS));
    dispatch(reloadSubscription());

    // Return the response data including next steps
    return {
      success: true,
      data: response?.data,
      nextSteps: response?.data?.nextSteps
    };
  } catch (e) {
    const {
      message
    } = e?.response?.data || {};
    dispatch({
      type: SUBSCRIBE_ERROR,
    });
    dispatch(addNotification(SUBSCRIBE_ERROR, message || 'Something went wrong. Payment information not accepted.', NOTIFICATION_STATUS.ERROR));

    // Throw an error to create a rejected Promise
    const error = new Error(message || 'Something went wrong. Payment information not accepted.');
    error.success = false;
    error.originalError = message;
    throw error;
  }
};

export const cancelSubscriptionAtPeriodEnd = (userSubscriptionId, cancelAtPeriodEnd) => async (dispatch) => {
  dispatch({
    type: CANCEL_SUBSCRIPTION_AT_PERIOD_END,
  });
  try {
    const response = await axios.post('/api/usersubscription/cancel-at-period-end', {
      userSubscriptionId,
      cancelAtPeriodEnd,
    });

    dispatch({
      type: CANCEL_SUBSCRIPTION_AT_PERIOD_END_SUCCESS,
      payload: response?.data || {}
    });
  } catch (e) {
    const { message } = e?.response?.data || {};
    dispatch({
      type: CANCEL_SUBSCRIPTION_AT_PERIOD_END_ERROR,
    });
    dispatch(addNotification(CANCEL_SUBSCRIPTION_AT_PERIOD_END_ERROR, message || 'Server error', NOTIFICATION_STATUS.ERROR));
  }
};

export const unsubscribe = (userSubscriptionId) => async (dispatch) => {
  dispatch({
    type: UNSUBSCRIBE,
  });
  try {
    const response = await axios.post('/api/usersubscription/unsubscribe', { userSubscriptionId });

    dispatch({
      type: UNSUBSCRIBE_SUCCESS,
      payload: response?.data || {}
    });
  } catch (e) {
    const { message } = e?.response?.data || {};
    dispatch({
      type: UNSUBSCRIBE_ERROR,
    });
    dispatch(addNotification(UNSUBSCRIBE_ERROR, message || 'Server error', NOTIFICATION_STATUS.ERROR));
  }
};

export const updateSubscriptionPaymentMethod = (userSubscriptionId, stripePaymentMethodId) => async (dispatch) => {
  if (!stripePaymentMethodId || !userSubscriptionId) {
    dispatch(addNotification(UPDATE_SUBSCRIPTION_PAYMENT_METHOD_ERROR, 'Values stripePaymentMethodId or userSubscriptionId are undefined', NOTIFICATION_STATUS.ERROR));
  }

  dispatch({
    type: UPDATE_SUBSCRIPTION_PAYMENT_METHOD,
  });
  try {
    const response = await axios.put('/api/usersubscription/paymentmethod', {
      userSubscriptionId,
      stripePaymentMethodId,
    });

    dispatch({
      type: UPDATE_SUBSCRIPTION_PAYMENT_METHOD_SUCCESS,
      payload: response?.data || {}
    });
    dispatch(addNotification(UPDATE_SUBSCRIPTION_PAYMENT_METHOD_SUCCESS, 'Thank you! Payment information accepted.', NOTIFICATION_STATUS.SUCCESS));
    dispatch(reloadSubscription());
  } catch (e) {
    const { message } = e?.response?.data || {};
    dispatch({
      type: UPDATE_SUBSCRIPTION_PAYMENT_METHOD_ERROR,
    });
    dispatch(addNotification(UPDATE_SUBSCRIPTION_PAYMENT_METHOD_ERROR, message || 'Server error', NOTIFICATION_STATUS.ERROR));
  }
};

// CON-1481 — retry payment on the user's past-due metered invoices.
// On success the Stripe webhook clears userSubscription.meteredInvoiceUnpaid,
// so we just reload subscription state to pick that up.
export const retryMeteredInvoice = () => async (dispatch) => {
  dispatch({ type: RETRY_METERED_INVOICE });
  try {
    await axios.post('/api/usersubscription/retry-metered-invoice');
    dispatch({ type: RETRY_METERED_INVOICE_SUCCESS });
    dispatch(addNotification(
      RETRY_METERED_INVOICE_SUCCESS,
      'Payment successful — texting restored.',
      NOTIFICATION_STATUS.SUCCESS,
    ));
    dispatch(reloadSubscription());
  } catch (e) {
    const { message } = e?.response?.data || {};
    dispatch({ type: RETRY_METERED_INVOICE_ERROR });
    dispatch(addNotification(
      RETRY_METERED_INVOICE_ERROR,
      message || 'Payment failed. Please update your card and try again.',
      NOTIFICATION_STATUS.ERROR,
    ));
  }
};

export const createReferralCode = () => async (dispatch) => {
  dispatch({
    type: CREATE_REFERRAL_CODE,
  });
  try {
    const response = await axios.post('/api/usersubscription/create-referral-code', {});

    dispatch({
      type: CREATE_REFERRAL_CODE_SUCCESS,
      payload: response?.data || {}
    });
  } catch (e) {
    const { message } = e?.response?.data || {};
    dispatch({
      type: CREATE_REFERRAL_CODE_ERROR,
    });
    dispatch(addNotification(CREATE_REFERRAL_CODE_ERROR, message || 'Server error', NOTIFICATION_STATUS.ERROR));
  }
};

export const applyReferralCode = (values, doWhenTry = () => { }) => async (dispatch) => {
  dispatch({
    type: APPLY_REFERRAL_CODE,
    payload: values,
  });
  try {
    const response = await axios.post('/api/usersubscription/save-referred-salesperson', values);

    dispatch({
      type: APPLY_REFERRAL_CODE_SUCCESS,
      payload: response?.data || {}
    });

    doWhenTry();
  } catch (e) {
    const { message } = e?.response?.data || {};
    dispatch({
      type: APPLY_REFERRAL_CODE_ERROR,
    });
    dispatch(addNotification(APPLY_REFERRAL_CODE_ERROR, message || 'Server error', NOTIFICATION_STATUS.ERROR));
  }
};

export const confirmIsAConsultant = (code, emailProvider, doWhenTry = false, doWhenCatch = false) => async (dispatch) => {
  try {
    dispatch({
      type: CONFIRM_CONSULTANT
    });

    const response = await axios.post('/api/emailSettings/confirmIsAConsultant', { code, emailProvider });
    const {
      success,
    } = response?.data || {};

    if (!success) {
      dispatch(addNotification(CONFIRM_CONSULTANT_ERROR, 'Could Not Confirm Which Company You are With', NOTIFICATION_STATUS.ERROR));
      dispatch({
        type: CONFIRM_CONSULTANT_ERROR,
      });
      return;
    }

    dispatch(addNotification(CONFIRM_CONSULTANT_SUCCESS, 'Successfully Confirmed Your Company', NOTIFICATION_STATUS.SUCCESS));

    dispatch({
      type: CONFIRM_CONSULTANT_SUCCESS,
    });

    if (doWhenTry) {
      doWhenTry();
    }
  } catch (e) {
    const {
      message,
      error,
    } = e?.response?.data || {};
    const { message: errorMessage } = error || {};
    dispatch(addNotification(CONFIRM_CONSULTANT_ERROR, message || errorMessage || error || 'Try again later', NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: CONFIRM_CONSULTANT_ERROR,
    });
    if (doWhenCatch) {
      doWhenCatch(e);
    }
  }
};

export const updateFiltersRules = (code, emailProvider, doWhenTry = false, doWhenCatch = false) => async (dispatch) => {
  try {
    dispatch({
      type: UPDATE_FILTERS
    });

    const response = await axios.put('/api/emailSettings/updateFiltersRules', { code, emailProvider });
    const {
      success,
    } = response?.data || {};

    if (!success) {
      dispatch(addNotification(UPDATE_FILTERS_ERROR, "Could Not (Fully) Update Your Email's Filters/Rules", NOTIFICATION_STATUS.ERROR));
      dispatch({
        type: UPDATE_FILTERS_ERROR,
      });
      return;
    }

    dispatch(addNotification(UPDATE_FILTERS_SUCCESS, "Successfully Updated Your Email's Filters/Rules", NOTIFICATION_STATUS.SUCCESS));

    dispatch({
      type: UPDATE_FILTERS_SUCCESS,
    });

    if (doWhenTry) {
      doWhenTry();
    }
  } catch (e) {
    const {
      message,
      error,
    } = e?.response?.data || {};
    const { message: errorMessage } = error || {};
    dispatch(addNotification(UPDATE_FILTERS_ERROR, message || errorMessage || error || 'Try again later', NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: UPDATE_FILTERS_ERROR,
    });
    if (doWhenCatch) {
      doWhenCatch(e);
    }
  }
};

export const getPhoneNumberPortDetails = () => async (dispatch) => {
  dispatch({ type: GET_PHONE_NUMBER_PORT_DETAILS });

  try {
    const response = await axios.get('/api/accountsettings/phone-port');

    const { error } = response?.data || {};
    if (error) {
      dispatch(addNotification(GET_PHONE_NUMBER_PORT_DETAILS_ERROR, error, NOTIFICATION_STATUS.ERROR));
      dispatch({
        type: GET_PHONE_NUMBER_PORT_DETAILS_ERROR,
      });
      return;
    }

    dispatch({
      type: GET_PHONE_NUMBER_PORT_DETAILS_SUCCESS,
      payload: response?.data || {},
    });
  } catch (e) {
    const {
      error,
      message,
    } = e?.response?.data || {};
    dispatch(addNotification(GET_PHONE_NUMBER_PORT_DETAILS_ERROR, helpers.transform.toString(message || error || 'Server error'), NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: GET_PHONE_NUMBER_PORT_DETAILS_ERROR,
    });
  }
};

export const updatePhoneNumberPortDetails = (salespersonId, portData) => async (dispatch) => {
  dispatch({ type: UPDATE_PHONE_NUMBER_PORT_DETAILS });

  try {
    const response = await axios.put('/api/accountsettings/phone-port', portData);

    const { error } = response?.data || {};
    if (error) {
      dispatch(addNotification(UPDATE_PHONE_NUMBER_PORT_DETAILS_ERROR, error, NOTIFICATION_STATUS.ERROR));
      dispatch({
        type: UPDATE_PHONE_NUMBER_PORT_DETAILS_ERROR,
      });
      return;
    }

    dispatch({
      type: UPDATE_PHONE_NUMBER_PORT_DETAILS_SUCCESS,
      payload: response?.data || {},
    });
  } catch (e) {
    const {
      error,
      message,
    } = e?.response?.data || {};
    dispatch(addNotification(UPDATE_PHONE_NUMBER_PORT_DETAILS_ERROR, helpers.transform.toString(message || error || 'Server error'), NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: UPDATE_PHONE_NUMBER_PORT_DETAILS_ERROR,
    });
  }
};

export const submitPhoneNumberPortRequest = (salespersonId, portData) => async (dispatch) => {
  dispatch({ type: SUBMIT_PHONE_NUMBER_PORT_REQUEST });

  try {
    const response = await axios.post('/api/accountsettings/phone-port', portData);

    const { error } = response?.data || {};
    if (error) {
      dispatch(addNotification(SUBMIT_PHONE_NUMBER_PORT_REQUEST_ERROR, error, NOTIFICATION_STATUS.ERROR));
      dispatch({
        type: SUBMIT_PHONE_NUMBER_PORT_REQUEST_ERROR,
      });
      return { error: true, message: error };
    }

    dispatch({
      type: SUBMIT_PHONE_NUMBER_PORT_REQUEST_SUCCESS,
      payload: response?.data || {},
    });

    // CON-1488: suppress the generic success toast for draft saves. The
    // caller (AccountDetailsStep) shows a draft-specific snackbar; this
    // copy ("Port request submitted") is inaccurate when mode='draft'
    // since the Telnyx port API was NOT called. mode='submit' (the real
    // port submission from AuthorizationStep) and undefined (legacy
    // callers) keep the existing notification.
    if (portData?.mode !== 'draft') {
      dispatch(addNotification(SUBMIT_PHONE_NUMBER_PORT_REQUEST_SUCCESS, 'Port request submitted successfully', NOTIFICATION_STATUS.SUCCESS));
    }

    return { success: true, data: response?.data };
  } catch (e) {
    const {
      error,
      message,
    } = e?.response?.data || {};
    dispatch(addNotification(SUBMIT_PHONE_NUMBER_PORT_REQUEST_ERROR, helpers.transform.toString(message || error || 'Server error'), NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: SUBMIT_PHONE_NUMBER_PORT_REQUEST_ERROR,
    });
    return { error: true, message: message || error || 'Server error' };
  }
};

export const setFillDefaultValues = (fillDefaultValues) => ({
  type: SET_FILL_DEFAULT_VALUES,
  payload: fillDefaultValues
});

export const setVisibleModalFormNumber = (modalNumber) => ({
  type: SET_VISIBLE_MODAL_FORM_NUMBER,
  payload: modalNumber
});

export const finishPhoneNumberPort = (portId) => async (dispatch) => {
  dispatch({ type: FINISH_PHONE_NUMBER_PORT });

  try {
    const response = await axios.post('/api/accountsettings/phone-port/finish', { portId });

    const { error } = response?.data || {};
    if (error) {
      dispatch(addNotification(FINISH_PHONE_NUMBER_PORT_ERROR, error, NOTIFICATION_STATUS.ERROR));
      dispatch({
        type: FINISH_PHONE_NUMBER_PORT_ERROR,
      });
      return { error: true, message: error };
    }

    dispatch({
      type: FINISH_PHONE_NUMBER_PORT_SUCCESS,
      payload: response?.data || {},
    });

    dispatch(addNotification(FINISH_PHONE_NUMBER_PORT_SUCCESS, 'Port completion request submitted successfully', NOTIFICATION_STATUS.SUCCESS));

    // Refresh the port details to get updated data
    dispatch(getPhoneNumberPortDetails());

    return { success: true, data: response?.data };
  } catch (e) {
    const {
      error,
      message,
    } = e?.response?.data || {};
    dispatch(addNotification(FINISH_PHONE_NUMBER_PORT_ERROR, helpers.transform.toString(message || error || 'Server error'), NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: FINISH_PHONE_NUMBER_PORT_ERROR,
    });
    return { error: true, message: message || error || 'Server error' };
  }
};

// Lumian Porting v2: Submit Now on the Status step, for a v2 port that was
// not sent (details were missing, or the send failed). The server answers
// with the consultant-facing message either way. The caller refreshes
// account info; this refreshes the port details.
export const submitPhonePortNow = (salespersonId, portId) => async (dispatch) => {
  dispatch({ type: SUBMIT_PHONE_PORT_NOW });

  try {
    const response = await axios.post('/api/accountsettings/phone-port/submit-now', { portId });

    const { error, message } = response?.data || {};
    if (error) {
      dispatch(addNotification(SUBMIT_PHONE_PORT_NOW_ERROR, error, NOTIFICATION_STATUS.ERROR));
      dispatch({ type: SUBMIT_PHONE_PORT_NOW_ERROR });
      return { error: true, message: error };
    }

    dispatch({ type: SUBMIT_PHONE_PORT_NOW_SUCCESS, payload: response?.data || {} });
    dispatch(addNotification(
      SUBMIT_PHONE_PORT_NOW_SUCCESS,
      message || 'Your port request was sent to your carrier.',
      NOTIFICATION_STATUS.SUCCESS,
    ));
    await dispatch(getPhoneNumberPortDetails(salespersonId));

    return { success: true, data: response?.data };
  } catch (e) {
    const {
      error,
      message,
    } = e?.response?.data || {};
    dispatch(addNotification(SUBMIT_PHONE_PORT_NOW_ERROR, helpers.transform.toString(message || error || 'Server error'), NOTIFICATION_STATUS.ERROR));
    dispatch({ type: SUBMIT_PHONE_PORT_NOW_ERROR });
    // The row may have changed (a failed send is marked on the server)
    await dispatch(getPhoneNumberPortDetails(salespersonId));
    return { error: true, message: message || error || 'Server error' };
  }
};

// CON-1721 — abandon a saved (never-submitted) port draft.
//
// Deliberately does NOT dispatch its own success notification: the caller
// immediately refreshes account info and opens the choose-a-number modal,
// and a toast on top of that is noise. Failures DO notify, because the
// whole point of the endpoint is that the caller must not navigate when
// the draft is still there — silently landing on the Subscription tab
// with no modal is the bug this ticket fixes.
export const abandonPhoneNumberPortDraft = (portId) => async (dispatch) => {
  dispatch({ type: ABANDON_PHONE_NUMBER_PORT_DRAFT });

  try {
    const response = await axios.post('/api/accountsettings/phone-port/abandon-draft', { portId });

    const { error } = response?.data || {};
    if (error) {
      dispatch(addNotification(ABANDON_PHONE_NUMBER_PORT_DRAFT_ERROR, error, NOTIFICATION_STATUS.ERROR));
      dispatch({ type: ABANDON_PHONE_NUMBER_PORT_DRAFT_ERROR });
      return { error: true, message: error };
    }

    dispatch({
      type: ABANDON_PHONE_NUMBER_PORT_DRAFT_SUCCESS,
      payload: response?.data || {},
    });

    return { success: true, data: response?.data };
  } catch (e) {
    const {
      error,
      message,
    } = e?.response?.data || {};
    dispatch(addNotification(
      ABANDON_PHONE_NUMBER_PORT_DRAFT_ERROR,
      helpers.transform.toString(message || error || 'Server error'),
      NOTIFICATION_STATUS.ERROR,
    ));
    dispatch({ type: ABANDON_PHONE_NUMBER_PORT_DRAFT_ERROR });
    return { error: true, message: message || error || 'Server error' };
  }
};

export const getContactCard = () => async (dispatch) => {
  dispatch({ type: GET_CONTACT_CARD });

  try {
    const response = await axios.get('/api/accountsettings/contact-card');

    const { error } = response?.data || {};
    if (error) {
      dispatch({
        type: GET_CONTACT_CARD_ERROR,
      });
      return { error: true, message: error };
    }

    dispatch({
      type: GET_CONTACT_CARD_SUCCESS,
      payload: response?.data || {},
    });

    return { success: true, data: response?.data };
  } catch (e) {
    const {
      error,
      message,
    } = e?.response?.data || {};
    dispatch({
      type: GET_CONTACT_CARD_ERROR,
    });
    return { error: true, message: message || error || 'Server error' };
  }
};

export const updateContactCard = (contactCardData, doWhenTry = false, doWhenCatch = false) => async (dispatch) => {
  dispatch({ type: UPDATE_CONTACT_CARD });

  try {
    const response = await axios.put('/api/accountsettings/contact-card', contactCardData);

    const { error } = response?.data || {};
    if (error) {
      dispatch(addNotification(UPDATE_CONTACT_CARD_ERROR, error, NOTIFICATION_STATUS.ERROR));
      dispatch({
        type: UPDATE_CONTACT_CARD_ERROR,
      });

      if (doWhenCatch) {
        doWhenCatch({ message: error });
      }
      return { error: true, message: error };
    }

    dispatch({
      type: UPDATE_CONTACT_CARD_SUCCESS,
      payload: response?.data || {},
    });

    dispatch(addNotification(UPDATE_CONTACT_CARD_SUCCESS, 'Your Contact Card has been updated', NOTIFICATION_STATUS.SUCCESS));

    if (doWhenTry) {
      doWhenTry();
    }

    return { success: true };
  } catch (e) {
    const {
      error,
      message,
    } = e?.response?.data || {};
    dispatch(addNotification(UPDATE_CONTACT_CARD_ERROR, helpers.transform.toString(message || error || 'Server error'), NOTIFICATION_STATUS.ERROR));
    dispatch({
      type: UPDATE_CONTACT_CARD_ERROR,
    });

    if (doWhenCatch) {
      doWhenCatch(e);
    }
    return { error: true, message: message || error || 'Server error' };
  }
};

// Item B — read-only port-number availability check used by the Port tab on
// phone-field blur. Not a Redux action (no state to store); returns the
// result directly so the caller can show an inline error. Fails open
// (returns available:true) so a transient error never blocks the form —
// the authoritative reject still runs server-side on submit.
export const checkPhonePortNumberAvailability = async (phoneNumber) => {
  try {
    const response = await axios.get(
      '/api/accountsettings/phone-port/check-number-availability',
      { params: { phoneNumber } },
    );
    const { available, reason } = response?.data || {};
    return { available: available !== false, reason };
  } catch (e) {
    return { available: true };
  }
};

/* ***************************************************************************
 * Texting move (old provider -> new provider): one-time 6-digit code.
 *
 * These thunks never throw and never raise a notification; each returns
 * { ok, status, data } so the PIN form can show the server's message inline
 * under the field (bad code, too many resends) instead of in a toast.
 * status is the HTTP status, or 0 for a network failure.
 *************************************************************************** */
export const TELNYX_MIGRATION_PIN_CLEARED = '@accountSettings/telnyx-migration-pin-cleared';
export const TELNYX_MIGRATION_PIN_MODAL_REQUESTED = '@accountSettings/telnyx-migration-pin-modal-requested';

// Re-open the code modal (the banner's "Enter code"), even after "Remind me
// later" hid it for the session.
export const openTelnyxMigrationPinModal = () => ({ type: TELNYX_MIGRATION_PIN_MODAL_REQUESTED });

const TELNYX_MIGRATION_PIN_URL = '/api/accountsettings/telnyx-migration/pin';

const toTelnyxMigrationResult = (response) => ({
  ok: true,
  status: response?.status || 200,
  data: response?.data || {},
});

const toTelnyxMigrationErrorResult = (e) => ({
  ok: false,
  status: e?.response?.status || 0,
  data: e?.response?.data || {},
});

// GET status. A 404, or a 200 that says the code is already verified or not
// required, means there is nothing for this user to do -- the stored login
// flag is cleared so the modal stops asking.
export const getTelnyxMigrationPinStatus = () => async (dispatch) => {
  try {
    const response = await axios.get(TELNYX_MIGRATION_PIN_URL);
    const result = toTelnyxMigrationResult(response);
    if (result.data?.verified === true || result.data?.required === false) {
      dispatch({ type: TELNYX_MIGRATION_PIN_CLEARED });
    }
    return result;
  } catch (e) {
    const result = toTelnyxMigrationErrorResult(e);
    if (result.status === 404) {
      dispatch({ type: TELNYX_MIGRATION_PIN_CLEARED });
    }
    return result;
  }
};

// POST the code. On success, clear the stored flag and refresh the account
// payload so the banner and flags reflect the new state.
export const verifyTelnyxMigrationPin = (otpPin) => async (dispatch) => {
  try {
    const response = await axios.post(TELNYX_MIGRATION_PIN_URL, { otpPin });
    const result = toTelnyxMigrationResult(response);
    if (result.data?.verified === true) {
      dispatch({ type: TELNYX_MIGRATION_PIN_CLEARED });
      dispatch(getAccountInfo());
    }
    return result;
  } catch (e) {
    const result = toTelnyxMigrationErrorResult(e);
    if (result.status === 404) {
      dispatch({ type: TELNYX_MIGRATION_PIN_CLEARED });
    }
    return result;
  }
};

export const resendTelnyxMigrationPin = () => async () => {
  try {
    const response = await axios.post(`${TELNYX_MIGRATION_PIN_URL}/resend`, {});
    return toTelnyxMigrationResult(response);
  } catch (e) {
    return toTelnyxMigrationErrorResult(e);
  }
};

// Dismiss the texting-move top banner. Best effort: the banner is hidden for
// the session on the client whatever this returns.
export const dismissTelnyxMigrationBanner = () => async () => {
  try {
    const response = await axios.post('/api/accountsettings/telnyx-migration/banner/dismiss', {});
    return toTelnyxMigrationResult(response);
  } catch (e) {
    return toTelnyxMigrationErrorResult(e);
  }
};
